/**
 * tdesign v1.1.1
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _slicedToArray } from '../_chunks/dep-605e961c.js';
import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import MessageClose from './MessageClose.js';
import MessageIcon from './MessageIcon.js';
import { useMessageClass } from './useMessageClass.js';
import { usePersistFn } from '../_util/usePersistFn.js';
import noop from '../_util/noop.js';
import '../_chunks/dep-f66447d3.js';
import 'tdesign-icons-react';
import '../hooks/useGlobalIcon.js';
import '../hooks/useConfig.js';
import '../config-provider/ConfigContext.js';
import '../_chunks/dep-8c8a3203.js';
import '../_chunks/dep-1d5f47c2.js';
import '../_chunks/dep-8670d51c.js';
import '../_chunks/dep-df9f8f04.js';
import '../_chunks/dep-9d326786.js';
import '../_chunks/dep-3542b5f1.js';
import '../_chunks/dep-79aca757.js';
import '../_chunks/dep-c7d784af.js';
import '../_chunks/dep-2055661d.js';
import '../_chunks/dep-73c3cd54.js';
import '../_chunks/dep-ced835e2.js';
import '../_chunks/dep-1e76a561.js';
import '../_chunks/dep-6b33e1e9.js';
import '../_chunks/dep-dae4a585.js';
import '../_chunks/dep-9e05eaf2.js';
import '../_chunks/dep-0d617aaa.js';
import '../_chunks/dep-030d278c.js';
import '../_chunks/dep-868937ef.js';
import '../_chunks/dep-6f5c07a7.js';
import '../_chunks/dep-a79a1775.js';
import '../_chunks/dep-7b744c82.js';
import '../_chunks/dep-0b20126b.js';
import '../_chunks/dep-2b7035c1.js';
import '../locale/zh_CN.js';
import '../_common/js/global-config/locale/zh_CN.js';
import 'dayjs';
import '../_chunks/dep-4fce6f2f.js';
import '../_common/js/global-config/default-config.js';
import '../loading/index.js';
import '../loading/Loading.js';
import '../_util/dom.js';
import 'raf';
import '../_chunks/dep-378695bd.js';
import '../_util/easing.js';
import '../common/Portal.js';
import 'react-dom';
import '../loading/gradient.js';
import '../hooks/useDomRefCallback.js';
import '../_common/js/loading/circle-adapter.js';
import '../_common/js/utils/set-style.js';
import '../_common/js/utils/helper.js';
import '../_chunks/dep-f41383e1.js';
import '../_chunks/dep-97bb7f6b.js';
import '../_chunks/dep-01305891.js';
import '../_chunks/dep-bd50d435.js';
import '../_chunks/dep-18226b92.js';
import '../loading/defaultProps.js';
import '../loading/plugin.js';
import '../_util/react-render.js';
import '../_chunks/dep-6ccd10f6.js';
import '../loading/style/css.js';
import '../loading/type.js';

var MessageComponent = function MessageComponent(props) {
  var _useMessageClass = useMessageClass(),
    tdMessagePrefix = _useMessageClass.tdMessagePrefix,
    tdClassIsGenerator = _useMessageClass.tdClassIsGenerator;
  var _props$theme = props.theme,
    theme = _props$theme === void 0 ? "info" : _props$theme,
    className = props.className,
    children = props.children,
    style = props.style,
    _props$icon = props.icon,
    icon = _props$icon === void 0 ? true : _props$icon,
    content = props.content,
    closeBtn = props.closeBtn,
    _props$onCloseBtnClic = props.onCloseBtnClick,
    onCloseBtnClick = _props$onCloseBtnClic === void 0 ? noop : _props$onCloseBtnClic,
    _props$onDurationEnd = props.onDurationEnd,
    onDurationEnd = _props$onDurationEnd === void 0 ? noop : _props$onDurationEnd,
    _props$onClose = props.onClose,
    onClose = _props$onClose === void 0 ? noop : _props$onClose,
    duration = props.duration;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isHovering = _useState2[0],
    setIsHovering = _useState2[1];
  var onCloseFn = usePersistFn(onClose);
  var onDurationEndFn = usePersistFn(onDurationEnd);
  var onCloseBtnClickFn = usePersistFn(onCloseBtnClick);
  function handleCloseBtnClick(e) {
    onCloseBtnClickFn(e);
    onCloseFn({
      trigger: "close-click"
    });
  }
  useEffect(function () {
    if (!isHovering && duration > 0) {
      var timer = setTimeout(function () {
        onDurationEndFn();
        onCloseFn({
          trigger: "duration-end"
        });
      }, duration);
      return function () {
        clearTimeout(timer);
      };
    }
  }, [duration, isHovering, onCloseFn, onDurationEndFn]);
  return /* @__PURE__ */React.createElement("div", {
    key: "message",
    style: style,
    className: classNames(className, "".concat(tdMessagePrefix), tdClassIsGenerator(theme), closeBtn ? tdClassIsGenerator("closable") : ""),
    onMouseEnter: function onMouseEnter() {
      return setIsHovering(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setIsHovering(false);
    }
  }, icon === true ? /* @__PURE__ */React.createElement(MessageIcon, {
    theme: theme
  }) : icon, content ? content : children, /* @__PURE__ */React.createElement(MessageClose, {
    closeBtn: closeBtn,
    onCloseBtnClick: handleCloseBtnClick
  }));
};

export { MessageComponent as default };
//# sourceMappingURL=MessageComponent.js.map
